import { useEffect, useState } from 'react';

/**
 * Detects, on mount, whether a given element is rendered inside a transparent
 * header — i.e. any element carrying the `headerClassName` class contains the
 * element identified by `elementId` (at any depth).
 *
 * Note: the check runs once on mount, so the target DOM is expected to exist at
 * that point (same behavior as the original inline effect).
 *
 * @param {string} elementId       id of the element to look for. Defaults to `sign-in-create-account`.
 * @param {string} headerClassName class marking a transparent header. Defaults to `header-transparent`.
 * @returns {boolean} whether the element lives inside a transparent header.
 */
const useTransparentHeader = (elementId = 'sign-in-create-account', headerClassName = 'header-transparent') => {
  const [isTransparentHeader, setIsTransparentHeader] = useState(false);

  useEffect(() => {
    const container = document.getElementById(elementId);
    const isInsideTransparentHeader =
      !!container &&
      Array.from(document.getElementsByClassName(headerClassName)).some(header => header.contains(container));
    setIsTransparentHeader(isInsideTransparentHeader);
  }, [elementId, headerClassName]);

  return isTransparentHeader;
};

export default useTransparentHeader;
